import React from 'react';
import { isBrandOV, isBrandAP, isBrandAC, isBrandDS, isMarketGB } from '../../../constants/main';
import { VehicleSummaryStyled } from '@components/v2/VehicleSummary/VehicleSummaryStyled';
import { VehicleSummaryStyledAC } from './AC/VehicleSummaryStyled.AC';
import { VehicleSummaryStyledAP } from './AP/VehicleSummaryStyled.AP';
import { VehicleSummaryStyledDS } from './DS/VehicleSummaryStyled.DS';
import { VehicleSummaryStyledOV } from './OV/VehicleSummaryStyled.OV';
import { VehicleSummaryStyledOV as VehicleSummaryStyledOV_GB } from './OV/GB/VehicleSummaryStyled.OV';
import { SC } from '../../../styles/theme';

export interface Props extends SC {}

const VehicleSummary = (props: Props) => {
    if (isBrandAC) return <VehicleSummaryStyledAC {...props} />;
    if (isBrandAP) return <VehicleSummaryStyledAP {...props} />;
    if (isBrandDS) return <VehicleSummaryStyledDS {...props} />;
    if (isBrandOV) return isMarketGB ? <VehicleSummaryStyledOV_GB {...props} /> : <VehicleSummaryStyledOV {...props} />;
    return <VehicleSummaryStyled {...props} />;
};

export default VehicleSummary;
